/* src/app/core/partials/parts-view/parts-view.component.scss */
/*# sourceMappingURL=parts-view.component.css.map */
